var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightBrandGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.119 6.81928L8.315 11.5823L6.964 13.0563L0.159 6.81928L6.964 0.582275L8.315 2.05628L3.119 6.81928Z",
    fill: "#94BE43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBrandGreen);
export default __webpack_public_path__ + "static/media/ChevronRightBrandGreen.834ef7dee904e8e8defa7787d3e7593e.svg";
export { ForwardRef as ReactComponent };